import { combineReducers } from 'redux';

import * as actionTypes from '../action-mgr/actionTypes';
import * as systemActionTypes from '../../system/action-creator/actionTypes';

const lastFastData = (state = null, action) => {
  switch (action.type) {
    case actionTypes.ADD_LIVE_STATION_RECORD:
      return action.record;
    case actionTypes.SELECT_LIVE_STATION:
    case systemActionTypes.LOGOUT_REQUEST:
    case actionTypes.CLEAR_STATION_DATA:
      return null;
    default:
      return state;
  }
}

const ipaLineChartData = (state = [], action) => {
  switch (action.type) {
    case actionTypes.ADD_LIVE_STATION_RECORD:
      return state.length < 7200 ?
        [
          ...state, action.graphDataItem
        ]
        :
        [
          ...state.slice(1, state.length),
          action.graphDataItem
        ];
    case actionTypes.SELECT_LIVE_STATION:
    case systemActionTypes.LOGOUT_REQUEST:
    case actionTypes.CLEAR_STATION_DATA:
      return [];
    default:
      return state;
  }
}

// const ipaLineChartData = (state = [], action) => {
//   switch (action.type) {
//     case actionTypes.ADD_LIVE_STATION_RECORD:
//       // Simply append the new graph data item without limiting the array size
//       return [...state, action.graphDataItem];

//     case actionTypes.SELECT_LIVE_STATION:
//     case systemActionTypes.LOGOUT_REQUEST:
//     case actionTypes.CLEAR_STATION_DATA:
//       // Reset the data to an empty array in these cases
//       return [];

//     default:
//       return state;
//   }
// }

const selectedStationId = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_LIVE_STATION:
      return action.stationId;
    case systemActionTypes.LOAD_USER_DATA_SUCCESS:
      return action.defaultStationId;
    case systemActionTypes.LOGOUT_REQUEST:
      return "";
    default:
      return state;
  }
}

const openedStationListDialog = (state = false, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_STATION_LIST_DIALOG:
      return !state;
    case actionTypes.SELECT_LIVE_STATION:
      return false;
    default:
      return state;
  }
}

const sitePhotos = (state = [], action) => {
  switch (action.type) {
    case actionTypes.SET_SITE_PHOTOS:
      return action.photos;
    case actionTypes.SELECT_LIVE_STATION:
      return [];
    default:
      return state;
  }
}

const selectedSitePhotoIndex = (state = -1, action) => {
  switch (action.type) {
    case actionTypes.SET_SITE_PHOTOINDEX:
      return action.index;
    case actionTypes.SELECT_LIVE_STATION:
      return -1;
    default:
      return state;
  }
}

const sitePhotosDisplayIntervalId = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.SET_SITE_PHOTOS_DISPLAY_INTERVAL_ID:
      return action.intervalId;
    default:
      return state;
  }
}

const stationTimeOffset = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SET_STATION_TIME_OFFSET:
      return action.stationTimeOffset;
    default:
      return state;
  }
}


const stnTotalize = (state = null, action) => {
  switch (action.type) {
    case actionTypes.GET_TOTALIZE:
      return action.data;
    default:
      return state;
  }
}


export default combineReducers({
  lastFastData,
  selectedStationId,
  openedStationListDialog,
  sitePhotos,
  selectedSitePhotoIndex,
  sitePhotosDisplayIntervalId,
  ipaLineChartData,
  stationTimeOffset,
  stnTotalize
});

const getCurrentState = state => state.fastData;

export const getStationTimeOffset = state => getCurrentState(state).stationTimeOffset;
export const getOpenedStationListDialog = state => getCurrentState(state).openedStationListDialog;
export const getCurrentFieldValue = (state, fieldName) => {
  const { lastFastData } = getCurrentState(state);
  if (lastFastData)
    return lastFastData[fieldName];
  return 0;
}

const getGaugeData = (state, field) => {

  const { lastFastData } = getCurrentState(state);

  if (lastFastData) {

    // console.log("getGaugeData")
    console.log(lastFastData)

    if (!lastFastData.Data) {
      return 0;
    } else {
      return lastFastData.Data[field];
    }
  }

  return 0;
}

export const getLastAmbientTemperature = state => getGaugeData(state, 'ambientTemperature');

export const getLastWindSpeed = state => getGaugeData(state, 'windSpeed');

export const getLastModuleTemperature = state => getGaugeData(state, 'moduleTemperature');

export const getLastHumidity = state => getGaugeData(state, 'humidity');

export const getLastWindDirection = state => getGaugeData(state, 'windDirection');

export const getCurrentPyranometerValue = state => getCurrentFieldValue(state, "pyranometer");

export const getCurrentIrradianceValue = state => getCurrentFieldValue(state, "irradiance");

export const getCurrentActivePowerValue = state => getCurrentFieldValue(state, "activePower");

export const getSelectedStationId = state => getCurrentState(state).selectedStationId;

export const getSitePhotos = state => getCurrentState(state).sitePhotos;

export const getSitePhotoIndex = state => getCurrentState(state).selectedSitePhotoIndex;

export const getSitePhotosDisplayIntervalId = state => getCurrentState(state).sitePhotosDisplayIntervalId;

export const getLastFastData = state => getCurrentState(state).lastFastData;

export const getLastDateTime = state => {
  const { lastFastData } = getCurrentState(state);
  if (lastFastData) {
    return lastFastData.timestamp;
  }

  return 0;
}

export const getAllLastData = state => getCurrentState(state).lastFastData;

export const getIpaLineChartDataV2 = state => getCurrentState(state).ipaLineChartData;

export const getStnTotalize = state => getCurrentState(state).stnTotalize;